<template lang="pug">
v-layout(column)
  //- v-subheader.pl-4.mt-3.pb-3 {{ $tf("process.list.title") }} / {{ $tf(`${definition.key}._process.name`, definition.name) }}
  v-layout(row grid-list-sm :class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
    v-card.grey.lighten-4.rounded-0(width="100%" elevation="0")
      v-toolbar.v-toolbar-responsive.white(flat card)
        v-toolbar-side-icon
          v-btn.my-0(icon :to="{name:'Home'}")
            v-icon(color="grey") arrow_back
        v-toolbar-title.ml-2
          v-avatar(size="40" v-if="!$vuetify.breakpoint.xsOnly" color="primary")
            v-icon.white--text.process-default-icon( :class="definition.id.split(':')[0]")
          span.font-weight-light.font-tight(:class="{ 'ml-3' : !$vuetify.breakpoint.xsOnly }" style="white-space: normal; line-height: 20px;") {{ $tf(`${definition.key}._process.name`, definition.name) }}
        v-spacer
        v-btn(icon)
          v-icon(color="grey") help
        //- v-btn.my-0(icon @click="diagram = true")
          v-icon(color="grey") timeline
        v-btn(icon @click="diagram = true")
          v-icon(color="grey") more_vert

      v-divider

      v-container.p-r(fluid grid-list-lg :class="[ !$vuetify.breakpoint.xsOnly ? 'pt-4' : 'pt-0' ]")
        //- v-card-text.pa-0(:class="{ 'px-0' : $vuetify.breakpoint.xsOnly }")
        slot
      v-divider

      v-toolbar.v-toolbar-responsive.white.py-2(flat card)
        v-spacer
        slot(name="footer")
        //- v-btn.px-4(:class="{ 'v-btn--outline v-btn--block v-btn--large' : $vuetify.breakpoint.xsOnly }"
              :to="{name:'ProcessList'}" color="grey lighten-1" outline flat) {{ $tf('process.start.cancel') }}

    wf-process-diagram(v-model="diagram" :processDefinitionId="definition.id" :processDefinitionName="$tf(`${definition.key}._process.name`, definition.name)")
</template>

<script>
import { mapGetters } from 'vuex'
import ProcessDiagram from '@/components/process/ProcessDiagram'

export default {
  name: 'ProcessStartTemplate',

  components: {
    'wf-process-diagram': ProcessDiagram,
  },

  data() {
    return {
      diagram: false,
      styleElement: null,
    }
  },

  computed: {
    ...mapGetters({
      definition: 'process/definition',
      style: 'process/style',
      loading: 'tools/loading',
      profile: 'auth/profile',
    }),
  },

  created() {
    if (this.style) {
      this.styleElement = document.createElement('style')
      this.styleElement.type = 'text/css'
      this.styleElement.innerText = this.style
      document.head.appendChild(this.styleElement)
    }
    window.scrollTo(0, 0)
  },

  beforeDestroy() {
    if (this.styleElement) {
      document.head.removeChild(this.styleElement)
    }
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/process/ProcessStartTemplate.vue